(() => {
  if (window.minismusUSPReady) return;
  window.minismusUSPReady = true;
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const list = root.querySelector('.mini-usp-list');
    const items = [...list.querySelectorAll('.mini-usp-item')];
    const mobile = matchMedia('(max-width:749px)');
    const abort = new AbortController();
    let index = Math.min(1, items.length - 1), timer, hovering = false;
    const on = (node, type, fn, options = {}) => node.addEventListener(type, fn, { ...options, signal: abort.signal });
    function stop() { clearTimeout(timer); }
    function schedule() {
      stop();
      if (!mobile.matches || hovering || document.hidden || list.querySelector(':focus-visible') || list.querySelector('details[open]') || items.length < 2) return;
      timer = setTimeout(() => { index = (index + 1) % items.length; render(); }, 5000);
    }
    function render() {
      items.forEach((item, i) => { item.hidden = mobile.matches && i !== index; });
      list.setAttribute('aria-live', 'off');
      schedule();
    }
    on(list, 'focusin', stop);
    on(list, 'focusout', () => queueMicrotask(schedule));
    on(root, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { hovering = true; stop(); } });
    on(root, 'pointerleave', () => { hovering = false; schedule(); });
    on(list, 'toggle', schedule, { capture: true });
    on(document, 'visibilitychange', schedule);
    on(document, 'click', (event) => {
      root.querySelectorAll('.mn-usp-shipping[open]').forEach(d => { if (!d.contains(event.target)) d.open = false; });
    });
    on(document, 'keydown', (event) => {
      if (event.key !== 'Escape') return;
      root.querySelectorAll('.mn-usp-shipping[open]').forEach(d => { d.open = false; d.querySelector('summary').focus(); });
    });
    on(mobile, 'change', render);
    root.classList.add('mn-usp-ready');
    render();
    instances.set(root, () => { stop(); abort.abort(); instances.delete(root); });
  }
  function init(scope) {
    if (scope.matches?.('[data-mn-usp]')) mount(scope);
    scope.querySelectorAll('[data-mn-usp]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of instances) if (event.target.contains(root)) destroy();
  });
})();

